import { PrefTypeConst } from "../constants"; 

/**
 * スケジュール区分 (ScheduleTypeEnum)
 */
export const ScheduleTypeConst = {
  NUMBERING: 1,
  BIDDING_START: 2,
  BIDDING_END: 3,
  APPLIED_END: 4,
  LOWEST_PRICE_DECISION_END: 5,
  PUBLISHED_START_AT: 6,
  BIDDING_CONFIRM: 7,
} as const;

/**
 * 保存対象のグループ定義
 * (次回入札日分: NEXT / 入札当日分: TODAY)
 */
export const NEXT_TASK_TYPES: number[] = [
  ScheduleTypeConst.NUMBERING, 
  ScheduleTypeConst.APPLIED_END, 
  ScheduleTypeConst.PUBLISHED_START_AT
];

export const TODAY_TASK_TYPES: number[] = [
  ScheduleTypeConst.BIDDING_START, 
  ScheduleTypeConst.BIDDING_END, 
  ScheduleTypeConst.LOWEST_PRICE_DECISION_END
];

/**
 * スケジュール設定画面に表示する業務フローの順序定義
 */
export const BiddingScheduleFlowSteps = [
  ScheduleTypeConst.APPLIED_END,              // 1. 提出締切
  ScheduleTypeConst.NUMBERING,                // 2.入札番号採番
  ScheduleTypeConst.PUBLISHED_START_AT,       // 3. 公開時刻
  ScheduleTypeConst.LOWEST_PRICE_DECISION_END, // 4. 最低落札値決定締切
  ScheduleTypeConst.BIDDING_START,             // 5. 入札開始
  ScheduleTypeConst.BIDDING_END,               // 6. 入札終了
] as const;

/**
 * スケジュール区分のラベル
 */
export const ScheduleTypeLabel = {
  [ScheduleTypeConst.NUMBERING]: "次回入札日分 : 入札番号採番",
  [ScheduleTypeConst.BIDDING_START]: "入札日当日 : 入札開始",
  [ScheduleTypeConst.BIDDING_END]: "入札日当日 : 入札締切",
  [ScheduleTypeConst.APPLIED_END]: "次回入札日分 : 提出締切",
  [ScheduleTypeConst.LOWEST_PRICE_DECISION_END]: "入札日当日 : 最低落札値決定締切",
  [ScheduleTypeConst.PUBLISHED_START_AT]: "次回入札日分 : 出品予定公開時刻",
} as const;

/**
 * 各系列の初期時刻設定（バックエンドから受け取る用）。
 * 入札会は県内県外の区別を持たないため PrefectureType=0 の器も用意する
 * （この器が無いと入札会で取得した時刻が捨てられる）。
 */
export const InitialBiddingScheduleTimes = {
  [PrefTypeConst.NONE]: {
    [ScheduleTypeConst.APPLIED_END]: "",
    [ScheduleTypeConst.NUMBERING]: "",
    [ScheduleTypeConst.PUBLISHED_START_AT]: "",
    [ScheduleTypeConst.LOWEST_PRICE_DECISION_END]: "",
    [ScheduleTypeConst.BIDDING_START]: "",
    [ScheduleTypeConst.BIDDING_END]: "",
  },
  [PrefTypeConst.INTERNAL]: {
    [ScheduleTypeConst.APPLIED_END]: "",
    [ScheduleTypeConst.NUMBERING]: "",
    [ScheduleTypeConst.PUBLISHED_START_AT]: "",
    [ScheduleTypeConst.LOWEST_PRICE_DECISION_END]: "",
    [ScheduleTypeConst.BIDDING_START]: "",
    [ScheduleTypeConst.BIDDING_END]: "",
  },
  [PrefTypeConst.EXTERNAL]: {
    [ScheduleTypeConst.APPLIED_END]: "",
    [ScheduleTypeConst.NUMBERING]: "",
    [ScheduleTypeConst.PUBLISHED_START_AT]: "",
    [ScheduleTypeConst.LOWEST_PRICE_DECISION_END]: "",
    [ScheduleTypeConst.BIDDING_START]: "",
    [ScheduleTypeConst.BIDDING_END]: "",
  }
} as const;

/**
 * 営業区分定数 (0: 営業日, 1: 非営業日)
 */
export const BusinessDayTypeConst = {
  BUSINESS_DAY: 0,
  NON_BUSINESS_DAY: 1,
} as const;

/**
 * 営業区分の表示ラベル
 */
export const BusinessDayTypeLabel = {
  [BusinessDayTypeConst.BUSINESS_DAY]: "営業日",
  [BusinessDayTypeConst.NON_BUSINESS_DAY]: "非営業日",
} as const;

/**
 * 営業区分セレクトボックス用オプション
 */
export const BusinessDayTypeOptions = Object.entries(BusinessDayTypeLabel).map(([value, label]) => ({
  value: Number(value),
  label: label,
}));